export default [
  { type: "xs", respon: 0, letters: 22 },
  { type: "sm", respon: 684, letters: 35 },
  { type: "sm", respon: 768, letters: 38 },
  { type: "sm", respon: 850, letters: 40 },
  { type: "md", respon: 960, letters: 115 },
  { type: "lg", respon: 1264, letters: 115 },
  { type: "xl", respon: 1904, letters: 140 },
];
